/* eslint-disable */

const PictrkKeyMap = {
  login: 'singup',
  memberShipPay: 'checkout',
  generateBtn: 'addtocart',
  modelDownload: 'pagevisit',
  imageDownload: 'watchvideo',
};

const RedditKeyMap = {
  login: 'SignUp',
  memberShipPay: 'Purchase',
  generateBtn: 'AddToCart',
  modelDownload: 'AddToWishlist',
  imageDownload: 'PageVisit',
};

/**
 * facebook/Reddit/Pinterst的事件上报
 * @param eventName
 * @param params
 */
export const metaReport = (eventName, params = {}) => {
  // eslint-disable-next-line no-undef
  window.fbq && window.fbq('trackCustom', eventName, { ...params });

  // eslint-disable-next-line
  window.rdt && window.rdt('track', 'Custom', { ...params, customEventName: RedditKeyMap[eventName] });

  // eslint-disable-next-line
  window.pintrk &&
    window.pintrk('track', PictrkKeyMap[eventName], {
      params,
    });
  console.info(`metaReport`, eventName, params);
};
